import styled from "styled-components";
import { Button } from "@mui/material";

export const ActionButton = styled(Button)`
  background: white;
  color: ${(p) => p.theme.palette.success.main};
  margin-top: 16px;
`;
